export const integerNumberOnly = ['seatingCapacity', 'licensePlateNumber']
